webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "05cz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ylw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-jumbotron',{attrs:{"lead":"Anhand der Seitenzahlen im Buch","id":"search-jumbo"}},[_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Resourcen nachschlagen")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"text-muted mb-0"},[_vm._v("Seitenzahl auswählen")]),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.lastPage,"per-page":1,"align":"center","hide-goto-end-buttons":true},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center"},[_c('resource-type-filter',{ref:"resourceTypeFilter",attrs:{"disabled":_vm.searchInput === '',"enable-default":"audio"}})],1),_vm._v(" "),_c('div',{staticClass:"mt-2 text-center d-none"},[_c('resource-lang-filter',{ref:"resourceLangFilter",attrs:{"disabled":_vm.searchInput === '',"enable-default-all":true}})],1)])],1),_vm._v(" "),_c('b-container',[_c('b-row',[_vm._l((_vm.searchResult),function(resource){return _c('b-col',{key:resource.filePath,staticClass:"mb-4",attrs:{"cols":"12"}},[_c('resource',{attrs:{"resource":resource}})],1)}),_vm._v(" "),(_vm.searchResult.length <= 0 && _vm.searchInput !== '')?_c('b-col',{staticClass:"fadeIn animated",attrs:{"id":"no-search-results"}},[_c('h3',[_vm._v("Keine Ergebnisse gefunden!")]),_vm._v(" "),_c('p',[_vm._v("Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien für die Seite "),_c('code',[_vm._v(_vm._s(_vm.searchInput))]),_vm._v(" gefunden werden.")]),_vm._v(" "),_c('p',[_vm._v("Dies kann auch daran liegen, dass noch keine Zusatzmaterialien für diese Seite erstellt wurden.")])]):_vm._e(),_vm._v(" "),(_vm.searchInput === '')?_c('b-col',{staticClass:"fadeIn animated",attrs:{"id":"no-search-results-no-input"}},[_c('h3',[_vm._v("Ungültige Seite aufgerufen")]),_vm._v(" "),_c('p',[_vm._v("Sie haben leider einen ungültigen Link aufgerufen.")])]):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "36Cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceList_vue__ = __webpack_require__("Egk2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33eb0715_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceList_vue__ = __webpack_require__("NNIB");
function injectStyle (ssrContext) {
  __webpack_require__("qQ2Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33eb0715"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33eb0715_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3SJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceKasaBook21_vue__ = __webpack_require__("shih");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819f722c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceKasaBook21_vue__ = __webpack_require__("5Z24");
function injectStyle (ssrContext) {
  __webpack_require__("n2q4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-819f722c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceKasaBook21_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_819f722c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceKasaBook21_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3b9N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Z24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"results"},[_c('b-row',[_vm._l((_vm.searchResult),function(resource){return _c('b-col',{key:resource.filePath,staticClass:"mb-4",attrs:{"cols":"12"}},[_c('resource',{attrs:{"resource":resource}})],1)}),_vm._v(" "),(_vm.searchResult.length <= 0)?_c('b-col',{staticClass:"fadeIn animated",attrs:{"id":"no-search-results"}},[_c('h3',[_vm._v("Kein Ergebnis gefunden!")]),_vm._v(" "),_c('p',[_vm._v("Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien unter diesem Link gefunden werden.")]),_vm._v(" "),_c('p',[_vm._v("Bitte prüfen Sie den Link, falls dieser korrekt sein sollte, kontaktieren Sie uns bitte.")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding-top":"30px","padding-bottom":"30px"}},[_c('b-button',{attrs:{"to":"/resources/list"}},[_vm._v("Alle Materialien ansehen")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7h2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base-container"}},[_c('navbar'),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1),_vm._v(" "),_c('cookie-law',{attrs:{"information-button-link":"/impress","close-button-variant":"success","information-button-text":"Mehr Informationen","close-button-text":"Okay!","theme":"gray-transparent"}},[_c('p',{attrs:{"slot":"message"},slot:"message"},[_vm._v("Diese Website benutzt Cookies. Durch die Nutzung des Angebots akzeptieren Sie unsere Datenschutzbedingungen.")])]),_vm._v(" "),_c('foot'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('noscript',[_c('p',[_c('img',{staticStyle:{"border":"0"},attrs:{"src":"https://matomo.giz.berlin/piwik.php?idsite=11&rec=1","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8MQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"results"},[_c('b-row',[_c('b-col',{staticClass:"mb-4",attrs:{"cols":"12"}},[_c('b-card',[_c('p',{staticClass:"card-text"},[_vm._v("\n            Hier können Sie die Materialien herunterladen. Der Download sollte automatisch starten. Wenn nicht, klicken Sie bitte auf "),_c('a',{attrs:{"target":"_blank","href":_vm.resourceLink,"title":"Material Herunterladen"}},[_vm._v("Herunterladen")]),_vm._v(".\n          ")]),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"mt-2 float-left"},[_vm._v("Material herunterladen")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"href":_vm.resourceLink,"target":"_blank","variant":"primary"}},[_c('icon',{attrs:{"name":"download"}}),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Herunterladen")])],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","padding-top":"30px","padding-bottom":"30px"}},[_c('b-button',{attrs:{"to":"/resources/list"}},[_vm._v("Kasa Materialien ansehen")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "91bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__ = __webpack_require__("bPT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__ = __webpack_require__("XZl9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Loki = __webpack_require__("7WZj");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceLookup',
  data: function data() {
    return {
      searchInput: 1
    };
  },

  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__["a" /* default */],
    ResourceLangFilter: __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__["a" /* default */]
  },
  mounted: function mounted() {
    this.$http.get('/static/resourceDB.json').then(function (response) {
      this.db = new Loki('resources');
      this.db.loadJSONObject(response.body);
      this.resourceCollection = this.db.getCollection('resources');

      if (this.$route.params.lang) {
        this.$refs.resourceLangFilter.selectOnlyLang(this.$route.params.lang);
        if (this.$route.params.page) {
          var intInput = parseInt(this.$route.params.page);
          if (!isNaN(intInput)) {
            this.searchInput = intInput;
          }
        }
      }
    });
  },

  watch: {
    searchInput: function searchInput(newVal, oldVal) {
      if (oldVal !== 1 && oldVal !== newVal) {
        this.$router.push({ path: '/resources/lookup/' + this.$route.params.lang + '/page/' + newVal });
      }
    }
  },
  computed: {
    filteredResources: function filteredResources() {
      var _this = this;

      if (this.resourceCollection !== null && this.resourceCollection !== undefined) {
        console.log('go');
        return this.resourceCollection.chain().where(function (obj) {
          if (_this.$refs.resourceTypeFilter !== undefined) {
            return _this.$refs.resourceTypeFilter.filterSelectedObjects(obj);
          }
          return false;
        }).where(function (obj) {
          if (_this.$refs.resourceLangFilter !== undefined) {
            return _this.$refs.resourceLangFilter.filterSelectedObjects(obj);
          }
          return false;
        });
      }
    },
    lastPage: function lastPage() {
      if (this.resourceCollection === null || this.resourceCollection === undefined) {
        return 999;
      }
      var lastRow = this.filteredResources.branch().simplesort('page', 'DESC').limit(1).data();
      return lastRow['page'];
    },
    searchResult: function searchResult() {
      var _this2 = this;

      if (this.searchInput === '' || this.resourceCollection === undefined || this.resourceCollection === null) {
        return [];
      }

      //

      return this.filteredResources.branch().where(function (obj) {
        var intInput = parseInt(_this2.searchInput);
        if (!isNaN(intInput)) {
          if (obj['page'] === intInput) {
            return true;
          }
        }
        return false;
      }).simplesort('page').data();
    }
  },
  methods: {
    getLanguageString: function getLanguageString(lang) {
      if (lang === 'ar') {
        return 'Arabisch';
      } else if (lang === 'tr') {
        return 'Türkisch';
      } else if (lang === 'pr') {
        return 'Persisch';
      } else {
        return 'Unbekannt';
      }
    }
  }
});

/***/ }),

/***/ "A7L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Oh no!")]),_vm._v(" "),_c('p',[_vm._v("Something went wrong :(")]),_vm._v(" "),_c('p',[_vm._v("Did you enter a correct URL?")]),_vm._v(" "),_c('p',[_vm._v("Please restart the application")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AKji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-alert',{attrs:{"show":""}},[_vm._v("\n      Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist\n      seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.\n    ")])],1),_vm._v(" "),_c('b-container',[_c('b-jumbotron',{attrs:{"lead":"Kostenlose Zusatzmaterialien zum Buch","id":"search-jumbo"}},[_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Resourcen finden")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"input-large","size":"lg","type":"text","placeholder":"Schnellzugriffscode, Seitenzahl oder Kapitel eingeben","autofocus":""},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}}),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center"},[_c('resource-type-filter',{ref:"resourceTypeFilter",attrs:{"disabled":_vm.searchInput === '',"enable-default-all":true}})],1),_vm._v(" "),_c('div',{staticClass:"mt-2 text-center"},[_c('resource-lang-filter',{ref:"resourceLangFilter",attrs:{"disabled":_vm.searchInput === '',"enable-default-all":true}})],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"results"},[_c('b-row',[_vm._l((_vm.searchResult),function(resource){return _c('b-col',{key:resource.filePath,staticClass:"mb-4",attrs:{"cols":"12"}},[_c('resource',{attrs:{"resource":resource}})],1)}),_vm._v(" "),(_vm.searchResult.length <= 0 && _vm.searchInput.length >= _vm.minSearchInput)?_c('b-col',{staticClass:"fadeIn animated",attrs:{"id":"no-search-results"}},[_c('h3',[_vm._v("Keine Ergebnisse gefunden!")]),_vm._v(" "),_c('p',[_vm._v("Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien für den Suchbegriff "),_c('code',[_vm._v(_vm._s(_vm.searchInput))]),_vm._v(" gefunden werden.")]),_vm._v(" "),_c('h4',[_vm._v("Wie suche ich richtig?")]),_vm._v(" "),_c('p',[_vm._v("Bitte geben Sie in das Suchfeld "),_c('b',[_vm._v("eine")]),_vm._v(" der folgenden drei Informationen ein:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Seitenzahl der Verlinkung")]),_vm._v(" "),_c('li',[_vm._v("Kapitelnummer der Verlinkung")]),_vm._v(" "),_c('li',[_vm._v("Schnellzugriffscode des Materials (z.B. "),_c('code',[_vm._v("tr_1")]),_vm._v(" oder "),_c('code',[_vm._v("ar_2")]),_vm._v(")")])]),_vm._v(" "),_c('p',[_vm._v("Stellen Sei außerdem sicher, dass Sie die gewünschten Typen von Materialien unter dem Suchfeld angewählt haben.")])]):_vm._e(),_vm._v(" "),(_vm.searchInput.length < _vm.minSearchInput && _vm.searchInput.length > 0)?_c('b-col',{staticClass:"fadeIn animated",attrs:{"id":"too-short-search"}},[_c('h3',[_vm._v("Eingegebener Suchbegriff zu kurz")]),_vm._v(" "),_c('p',[_vm._v("Bitte geben Sie einen Suchbegriff von mindestens "),_c('b',[_vm._v(_vm._s(_vm.minSearchInput)+" Zeichen")]),_vm._v(" ein.")])]):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AW70":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C+Qn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("tbYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D9uT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button-group',{class:{ 'd-inline': true, 'd-md-none': !_vm.alwaysVertical },attrs:{"size":"sm","vertical":""}},[_vm._l((_vm.fTypeButtons),function(btn,idx){return _c('b-button',{key:idx,attrs:{"pressed":btn.selected,"disabled":_vm.disabled,"variant":_vm.buttonVariant},on:{"update:pressed":function($event){_vm.$set(btn, "selected", $event)}}},[_vm._v("\n      "+_vm._s(btn.caption)+"\n      "),(btn.selected)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!btn.selected)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)}),_c('b-button',{attrs:{"pressed":_vm.showOtherFTypes,"variant":_vm.buttonVariant,"disabled":_vm.disabled},on:{"update:pressed":function($event){_vm.showOtherFTypes=$event}}},[_vm._v("\n      Andere\n      "),(_vm.showOtherFTypes)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!_vm.showOtherFTypes)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)],2),_vm._v(" "),(!_vm.alwaysVertical)?_c('b-button-group',{staticClass:"d-none d-md-inline",attrs:{"size":"sm"}},[_vm._l((_vm.fTypeButtons),function(btn,idx){return _c('b-button',{key:idx,attrs:{"pressed":btn.selected,"disabled":_vm.disabled,"variant":_vm.buttonVariant},on:{"update:pressed":function($event){_vm.$set(btn, "selected", $event)}}},[_vm._v("\n      "+_vm._s(btn.caption)+"\n      "),(btn.selected)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!btn.selected)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)}),_c('b-button',{attrs:{"pressed":_vm.showOtherFTypes,"variant":_vm.buttonVariant,"disabled":_vm.disabled},on:{"update:pressed":function($event){_vm.showOtherFTypes=$event}}},[_vm._v("\n      Andere\n      "),(_vm.showOtherFTypes)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!_vm.showOtherFTypes)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar'
});

/***/ }),

/***/ "Egk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourceTypeFilter__ = __webpack_require__("bPT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResourceLangFilter__ = __webpack_require__("XZl9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var Loki = __webpack_require__("7WZj");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceList',
  data: function data() {
    var languageButtons = [];
    var selected = true;
    for (var lang in __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* RESOURCES_LANGUAGES */]) {
      languageButtons.push({
        caption: __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* RESOURCES_LANGUAGES */][lang]['name'],
        langCode: lang,
        selected: selected
      });
      selected = false;
    }

    return {
      resourceCollection: null,
      db: null,
      languageButtons: languageButtons
    };
  },
  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_1__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_3__ResourceTypeFilter__["a" /* default */],
    ResourceLangFilter: __WEBPACK_IMPORTED_MODULE_4__ResourceLangFilter__["a" /* default */]
  },
  mounted: function mounted() {
    this.$http.get('/static/resourceDB.json').then(function (response) {
      var _this = this;

      this.db = new Loki('resources');
      this.db.loadJSONObject(response.body);
      this.resourceCollection = this.db.getCollection('resources');

      this.$nextTick(function () {
        _this.$forceUpdate();
      });
    });
  },

  computed: {
    filteredResources: function filteredResources() {
      var _this2 = this;

      if (this.resourceCollection !== null) {
        return this.resourceCollection.chain().where(function (obj) {
          return !obj.topic;
        }).where(function (obj) {
          return _this2.$refs.resourceLangFilter.filterSelectedObjects(obj);
        }).where(function (obj) {
          if (_this2.$refs.resourceTypeFilter !== undefined) {
            return _this2.$refs.resourceTypeFilter.filterSelectedObjects(obj);
          }
          return false;
        }).simplesort('page').simplesort('chapter').data();
      }
    },
    searchResult: function searchResult() {
      if (this.resourceCollection !== null) {
        return this.filteredResources;
      }
    },
    toc: function toc() {
      if (this.resourceCollection === null) {
        return {
          toc: []
        };
      }

      var entries = this.filteredResources;
      var chapters = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;

          if (chapters[entry['chapter']] === undefined) {
            chapters[entry['chapter']] = {
              count: 1,
              firstEntry: entry
            };
          } else {
            chapters[entry['chapter']]['count'] += 1;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        toc: chapters
      };
    }
  },
  methods: {
    getUniqueIdForEntry: function getUniqueIdForEntry(entry) {
      return 'entry_' + this.hashCode(entry.fileName + entry.title + entry.chapter);
    },
    offsetTop: function offsetTop(el) {
      // Return an element's offset wrt document element
      // https://j11y.io/jquery/#v=git&fn=jQuery.fn.offset
      if (!el.getClientRects().length) {
        return 0;
      }
      var bcr = el.getBoundingClientRect();
      var win = el.ownerDocument.defaultView;
      return bcr.top + win.pageYOffset;
    },
    scrollIntoView: function scrollIntoView(evt, href) {
      // taken from https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/docs/components/toc.vue
      evt.preventDefault();
      evt.stopPropagation();
      // We use an attribute `querySelector()` rather than `getElementByID()`,
      // as some auto-generated ID's are invalid or not unique
      var id = (href || '').replace(/#/g, '');
      var $el = document.body.querySelector('[id="' + id + '"]');
      if ($el) {
        // Get the document scrolling element
        var scroller = document.scrollingElement || document.documentElement || document.body;
        // Scroll heading into view (minus offset to account for nav top height
        scrollTo(scroller, this.offsetTop($el) - 70, 100, function () {
          // Set a tab index so we can focus header for a11y support
          $el.tabIndex = -1;
          // Focus the heading
          $el.focus();
        });
      }
    },

    hashCode: function hashCode(str) {
      // taken from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
      return str.split('').reduce(function (prevHash, currVal) {
        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
      }, 0);
    }
  }
});

/***/ }),

/***/ "Et53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__ = __webpack_require__("bPT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__ = __webpack_require__("XZl9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceKasaBook21m',
  data: function data() {
    return {
      resourceLink: '',
      resourceExt: ''
    };
  },

  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__["a" /* default */],
    ResourceLangFilter: __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    this.resourceLink = '/static/kasa_book_21/' + this.$route.params.item + '.' + this.$route.params.ext;
    this.resourceExt = this.$route.params.ext;
    setTimeout(function () {
      window.location.href = _this.resourceLink;
    }, 500);
  }
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "ICct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("oiih");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceLangFilter',
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    enableDefaultAll: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    alwaysVertical: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    var languageButtons = [];
    var selected = true;
    for (var lang in __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RESOURCES_LANGUAGES */]) {
      languageButtons.push({
        caption: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RESOURCES_LANGUAGES */][lang]['name'],
        langCode: lang,
        selected: selected
      });
      selected = this.enableDefaultAll;
    }

    return {
      languageButtons: languageButtons,
      showOtherFTypes: this.enableDefaultAll
    };
  },
  methods: {
    filterSelectedObjects: function filterSelectedObjects(obj) {
      if (obj['language'] === undefined) {
        return true;
      }
      for (var lang in this.languageButtons) {
        if (obj['language'] === this.languageButtons[lang]['langCode'] && this.languageButtons[lang]['selected']) {
          return true;
        }
      }
      return false;
    },
    selectOnlyLang: function selectOnlyLang(langCode) {
      for (var lang in this.languageButtons) {
        if (langCode === this.languageButtons[lang]['langCode']) {
          this.languageButtons[lang]['selected'] = true;
        } else {
          this.languageButtons[lang]['selected'] = false;
        }
      }
    }
  },
  computed: {
    buttonVariant: function buttonVariant() {
      if (this.disabled) {
        return 'outline-secondary';
      }
      return 'outline-primary';
    }
  }
});

/***/ }),

/***/ "KVrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("oiih");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceTypeFilter',
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    enableDefaultAll: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    enableDefault: {
      type: String,
      default: function _default() {
        return 'text';
      }
    },
    alwaysVertical: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    var fileButtons = [];
    for (var fType in __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FILE_TYPE_MAP */]) {
      var selected = void 0;
      if (fType === this.enableDefault) {
        selected = true;
      } else {
        selected = this.enableDefaultAll;
      }
      fileButtons.push({
        caption: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FILE_TYPE_MAP */][fType]['name'],
        fType: fType,
        selected: selected
      });
    }

    return {
      fTypeButtons: fileButtons,
      showOtherFTypes: this.enableDefaultAll
    };
  },
  methods: {
    filterSelectedObjects: function filterSelectedObjects(obj) {
      for (var fType in this.fTypeButtons) {
        if (obj['fileType'] === this.fTypeButtons[fType]['fType']) {
          if (this.fTypeButtons[fType]['selected']) {
            return true;
          } else {
            return false;
          }
        }
      }
      return this.showOtherFTypes;
    }
  },
  computed: {
    buttonVariant: function buttonVariant() {
      if (this.disabled) {
        return 'outline-secondary';
      }
      return 'outline-primary';
    }
  }
});

/***/ }),

/***/ "M/My":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25792847_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("7h2d");
function injectStyle (ssrContext) {
  __webpack_require__("05cz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25792847_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mk1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-alert',{attrs:{"show":""}},[_vm._v("\n      Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist\n      seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.\n    ")])],1),_vm._v(" "),_c('b-container',[_c('b-jumbotron',{attrs:{"lead":"Kostenlose Zusatzinhalte"}},[_c('h2',{attrs:{"slot":"header","id":"content-header"},slot:"header"},[_vm._v("Inhaltsverzeichnis")]),_vm._v(" "),_c('p',[_vm._v("\n        Hier finden Sie ein Inhaltsverzeichnis, welches alle unsere bisher erstellten zusätzlichen "),_c('b',[_vm._v("Inhalte")]),_vm._v(" auflistet.\n\n        Um nach Inhalten zu suchen, nutzen Sie bitte die "),_c('router-link',{attrs:{"to":"/resources/search"}},[_vm._v("Suchfunktion")]),_vm._v(".\n      ")],1)])],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('div',{staticClass:"filter-buttons"},[_c('p',{staticClass:"text-muted mb-0 mt-2"},[_vm._v("Typauswahl")]),_vm._v(" "),_c('resource-type-filter',{ref:"resourceTypeFilter",attrs:{"enableDefaultAll":true,"always-vertical":true}})],1),_vm._v(" "),_c('b-nav',{directives:[{name:"b-scrollspy",rawName:"v-b-scrollspy",value:(20),expression:"20"}],staticClass:"section-nav",attrs:{"vertical":""}},[_c('p',{staticClass:"text-muted mb-0 mt-2"},[_vm._v("Inhaltsübersicht | "),_c('a',{attrs:{"href":"#content-header"}},[_vm._v("Nach oben")])]),_vm._v(" "),_vm._l((_vm.toc.toc),function(chapter){return _c('li',{key:_vm.getUniqueIdForEntry(chapter.title),staticClass:"nav-item toc-entry toc-h2 mb-1"},[_c('b-link',{staticClass:"nav-link",attrs:{"href":'#' + _vm.getUniqueIdForEntry(chapter.title)},on:{"click":function($event){_vm.scrollIntoView($event, _vm.getUniqueIdForEntry(chapter.title))}}},[_c('span',[_vm._v(_vm._s(chapter.title)+" "),_c('b-badge',[_vm._v(_vm._s(_vm.topicSearchResultUnfiltered(chapter.title).length))])],1)])],1)})],2)],1),_vm._v(" "),(_vm.searchResult !== undefined)?_c('b-col',{attrs:{"md":"9"}},[_vm._l((_vm.searchResult),function(topic){return _c('div',[_c('h3',{attrs:{"id":_vm.getUniqueIdForEntry(topic.topic.title)}},[_vm._v(_vm._s(topic.topic.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(topic.topic.description))]),_vm._v(" "),_vm._l((topic.entries),function(resource){return _c('b-row',{key:resource.filePath,staticClass:"mb-4"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":_vm.getUniqueIdForEntry(resource.fileName)}},[_c('resource',{attrs:{"resource":resource}})],1)])],1)})],2)}),_vm._v(" "),(_vm.searchResult.length === 0)?_c('b-row',{staticClass:"mb-4"},[_c('b-col',{staticClass:"fadeIn animated",attrs:{"cols":"12","id":"no-search-results"}},[_c('h3',[_vm._v("Keine Ergebnisse gefunden!")]),_vm._v(" "),_c('p',[_vm._v("\n              Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien zu ihren Parametern gefunden werden.\n              Bitte stellen Sie sicher, dass Sie mindestens eine Sprache und einen Typ auswählen.\n            ")])])],1):_vm._e()],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_matomo__ = __webpack_require__("96K9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_matomo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_matomo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

if (true) {
  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_matomo___default.a, {
    // Configure your matomo server and site by providing
    host: 'https://matomo.giz.berlin',
    siteId: 11,

    // Changes the default .js and .php endpoint's filename
    // Default: 'piwik'
    trackerFileName: 'matomo',

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Enables automatically registering pageviews on the router
    router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]
  });
}

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].directive('set-class-on-scroll-vertical', {
  inViewport: function inViewport(el) {
    var rect = el.getBoundingClientRect();

    var offsetVertical = window.innerHeight / 4;

    return rect.top > offsetVertical && rect.top < window.innerHeight - offsetVertical || rect.bottom > offsetVertical && rect.bottom < window.innerHeight - offsetVertical;
  },
  bind: function bind(el, binding) {
    el.classList.add('invisible');
    el.$onScroll = function () {
      if (binding.def.inViewport(el)) {
        el.classList.add(binding.value);
        el.classList.remove('invisible');
        binding.def.unbind(el, binding);
      }
    };
    document.addEventListener('scroll', el.$onScroll);
  },
  inserted: function inserted(el) {
    el.$onScroll();
  },
  created: function created(el) {
    el.$onScroll();
  },
  unbind: function unbind(el) {
    document.removeEventListener('scroll', el.$onScroll);
    delete el.$onScroll;
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "NNIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-alert',{attrs:{"show":""}},[_vm._v("\n      Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist\n      seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.\n    ")])],1),_vm._v(" "),_c('b-container',[_c('b-jumbotron',{attrs:{"lead":"Kostenlose Zusatzmaterialien zum Buch"}},[_c('h2',{attrs:{"slot":"header","id":"content-header"},slot:"header"},[_vm._v("Inhaltsverzeichnis")]),_vm._v(" "),_c('p',[_vm._v("\n        Hier finden Sie ein Inhaltsverzeichnis, welches alle unsere bisher erstellten "),_c('b',[_vm._v("Zusatzmaterialien")]),_vm._v(" auflistet.\n\n        Um nach Inhalten zu einem Kaptiel zu suchen, nutzen Sie bitte die "),_c('router-link',{attrs:{"to":"/resources/search"}},[_vm._v("Suchfunktion")]),_vm._v(".\n      ")],1)])],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('div',{staticClass:"filter-buttons"},[_c('p',{staticClass:"text-muted mb-0"},[_vm._v("Sprachauswahl")]),_vm._v(" "),_c('resource-lang-filter',{ref:"resourceLangFilter",attrs:{"always-vertical":true}}),_vm._v(" "),_c('p',{staticClass:"text-muted mb-0 mt-2"},[_vm._v("Typauswahl")]),_vm._v(" "),_c('resource-type-filter',{ref:"resourceTypeFilter",attrs:{"always-vertical":true}})],1),_vm._v(" "),_c('b-nav',{directives:[{name:"b-scrollspy",rawName:"v-b-scrollspy",value:(20),expression:"20"}],staticClass:"section-nav",attrs:{"vertical":""}},[_c('p',{staticClass:"text-muted mb-0 mt-2"},[_vm._v("Kapitelübersicht | "),_c('a',{attrs:{"href":"#content-header"}},[_vm._v("Nach oben")])]),_vm._v(" "),_vm._l((_vm.toc.toc),function(chapter){return _c('li',{key:_vm.getUniqueIdForEntry(chapter.firstEntry),staticClass:"nav-item toc-entry toc-h2 mb-1"},[_c('b-link',{staticClass:"nav-link",attrs:{"href":'#' + _vm.getUniqueIdForEntry(chapter.firstEntry)},on:{"click":function($event){_vm.scrollIntoView($event, _vm.getUniqueIdForEntry(chapter.firstEntry))}}},[_c('span',[_vm._v("Kapitel "+_vm._s(chapter.firstEntry.chapter)+" "),_c('b-badge',[_vm._v(_vm._s(chapter.count))])],1)])],1)})],2)],1),_vm._v(" "),(_vm.searchResult !== undefined)?_c('b-col',{attrs:{"md":"9"}},[_vm._l((_vm.searchResult),function(resource){return _c('b-row',{key:resource.filePath,staticClass:"mb-4"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":_vm.getUniqueIdForEntry(resource)}},[_c('resource',{attrs:{"resource":resource}})],1)])],1)}),_vm._v(" "),(_vm.searchResult.length === 0)?_c('b-row',{staticClass:"mb-4"},[_c('b-col',{staticClass:"fadeIn animated",attrs:{"cols":"12","id":"no-search-results"}},[_c('h3',[_vm._v("Keine Ergebnisse gefunden!")]),_vm._v(" "),_c('p',[_vm._v("\n              Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien zu ihren Parametern gefunden werden.\n              Bitte stellen Sie sicher, dass Sie mindestens eine Sprache und einen Typ auswählen.\n            ")])])],1):_vm._e()],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QMEJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ScRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__ = __webpack_require__("glWq");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6e909d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__ = __webpack_require__("A7L0");
function injectStyle (ssrContext) {
  __webpack_require__("AW70")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6e909d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6e909d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TNpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceSearch_vue__ = __webpack_require__("hNTt");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c5d174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceSearch_vue__ = __webpack_require__("AKji");
function injectStyle (ssrContext) {
  __webpack_require__("oIcX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c5d174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c5d174_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Vej3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WWO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("oiih");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Resource',
  props: {
    resource: {}
  },
  methods: {
    getLanguageString: function getLanguageString(lang) {
      if (__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RESOURCES_LANGUAGES */][lang] === undefined) {
        throw Error('Unknown lang ' + lang);
      }
      return __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RESOURCES_LANGUAGES */][lang]['name'];
    }
  }
});

/***/ }),

/***/ "X22f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bmbf.7721cb1.svg";

/***/ }),

/***/ "XZl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceLangFilter_vue__ = __webpack_require__("ICct");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d1cdc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceLangFilter_vue__ = __webpack_require__("hT2Q");
function injectStyle (ssrContext) {
  __webpack_require__("M/My")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68d1cdc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceLangFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d1cdc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceLangFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/tr',
    redirect: '/resources'
  },
  // backward compatibility
  {
    path: '/resources',
    redirect: '/resources/search'
  }, {
    path: '/tr_:id',
    redirect: function redirect(to) {
      if (to.params.id) {
        return '/resources/search/tr_:id';
      }
    }
  }, {
    path: '/ar',
    redirect: '/resources'
  }, {
    path: '/ar_:id',
    redirect: function redirect(to) {
      if (to.params.id) {
        return '/resources/search/ar_:id';
      }
    }
  }, {
    path: '/pr',
    redirect: '/resources'
  }, {
    path: '/pr_:id',
    redirect: function redirect(to) {
      if (to.params.id) {
        return '/resources/search/pr_:id';
      }
    }
  },
  // Kasa videos (addition to the book 19)
  {
    path: '/kv21/:lang/:id',
    redirect: function redirect(to) {
      if (to.params.id) {
        return '/resources/search/:lang_vid_:id';
      }
    }
  },
  // Kasa audios in alpha 3 (addition to the book 19)
  {
    path: '/ka321/:lang/:id',
    redirect: function redirect(to) {
      if (to.params.id) {
        return {
          path: '/resources/search/alpha3_2_:id',
          query: {
            lang: to.params.lang
          }
        };
      }
    }
  }, {
    path: '/b19/:lang/p/:page',
    redirect: function redirect(to) {
      if (to.params.page && to.params.lang) {
        return '/resources/lookup/:lang/page/:page';
      }
    }
  }, {
    path: '/z20/:category/:item',
    redirect: function redirect(to) {
      if (to.params.category && to.params.item) {
        return '/resources/search/' + to.params.category + '_' + to.params.item;
      }
    }
  },
  // SuRe 2021 book
  {
    path: '/s21/:item',
    redirect: function redirect(to) {
      if (to.params.item && __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* SURE_BOOK_21_REDIRECTIONS */][to.params.item] !== undefined) {
        location.href = __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* SURE_BOOK_21_REDIRECTIONS */][to.params.item];
      }
    }
  },
  // Kasa 2021 book
  {
    path: '/k21/:item',
    redirect: function redirect(to) {
      if (to.params.item && __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* KASA_BOOK_21_REDIRECTIONS */][to.params.item] !== undefined) {
        location.href = __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* KASA_BOOK_21_REDIRECTIONS */][to.params.item];
      } else {
        return '/resources/k21/' + to.params.item;
      }
    }
  },
  // Material of kasa 2021 book (links directly to content, which couldn't be printed in the book)
  {
    path: '/k21m/:item/:ext',
    name: 'ResoureceK21m',
    component: __webpack_require__("v4ny").default
    // redirect: to => {
    //   window.location.href = `/static/kasa_book_21/${to.params.item}.${to.params.ext}`
    // }
  }, {
    path: '/resources/k21/:searchString',
    name: 'ResourceSearchK21',
    component: __webpack_require__("3SJW").default
  }, {
    path: '/home',
    name: 'Home',
    component: __webpack_require__("lO7g").default
  }, {
    path: '/resources/search',
    name: 'ResourceSearch',
    component: __webpack_require__("TNpH").default
  }, {
    path: '/resources/list',
    name: 'ResourceList',
    component: __webpack_require__("36Cd").default
  }, {
    path: '/resources/topicList',
    name: 'ResourceTopicList',
    component: __webpack_require__("p7qi").default
  }, {
    path: '/resources/search/:searchString',
    name: 'ResourceSearchWithString',
    component: __webpack_require__("TNpH").default
  }, {
    path: '/resources/lookup/:lang/page/:page',
    name: 'ResourceLookupLangPage',
    component: __webpack_require__("faP5").default
  }, {
    path: '/impress',
    name: 'Impress',
    component: __webpack_require__("Yal0").default
  }, {
    path: '*',
    name: 'error',
    component: __webpack_require__("ScRE").default
  }]
}));

/***/ }),

/***/ "Yal0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impress_vue__ = __webpack_require__("uq+p");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1c938d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impress_vue__ = __webpack_require__("mFnw");
function injectStyle (ssrContext) {
  __webpack_require__("vS+j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c1c938d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1c938d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bPT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceTypeFilter_vue__ = __webpack_require__("KVrO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be4d84f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceTypeFilter_vue__ = __webpack_require__("D9uT");
function injectStyle (ssrContext) {
  __webpack_require__("lJOY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6be4d84f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceTypeFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be4d84f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceTypeFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "egv2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alphabund_mid.726a286.jpeg";

/***/ }),

/***/ "faP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceLookup_vue__ = __webpack_require__("91bC");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa3604a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceLookup_vue__ = __webpack_require__("0ylw");
function injectStyle (ssrContext) {
  __webpack_require__("QMEJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4aa3604a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceLookup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa3604a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceLookup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "glWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'error'
});

/***/ }),

/***/ "hNTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__ = __webpack_require__("bPT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__ = __webpack_require__("XZl9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Loki = __webpack_require__("7WZj");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceSearch',
  data: function data() {
    return {
      searchInput: '',
      minSearchInput: 3
    };
  },

  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__["a" /* default */],
    ResourceLangFilter: __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__["a" /* default */]
  },
  mounted: function mounted() {
    this.$http.get('/static/resourceDB.json').then(function (response) {
      this.db = new Loki('resources');
      this.db.loadJSONObject(response.body);
      this.resourceCollection = this.db.getCollection('resources');
      this.topicsCollection = this.db.getCollection('topics');

      if (this.$route.params.searchString) {
        this.searchInput = this.$route.params.searchString;
      }

      if (this.$route.query.lang) {
        this.$refs.resourceLangFilter.selectOnlyLang(this.$route.query.lang);
      }
    });
  },

  computed: {
    filteredResources: function filteredResources() {
      var _this = this;

      if (this.resourceCollection !== null) {
        return this.resourceCollection.chain().where(function (obj) {
          if (_this.$refs.resourceTypeFilter !== undefined) {
            return _this.$refs.resourceTypeFilter.filterSelectedObjects(obj);
          }
          return false;
        }).where(function (obj) {
          if (_this.$refs.resourceLangFilter !== undefined) {
            return _this.$refs.resourceLangFilter.filterSelectedObjects(obj);
          }
          return false;
        });
      }
    },
    searchResult: function searchResult() {
      var _this2 = this;

      if (this.searchInput === '' || this.searchInput.length < this.minSearchInput) {
        return [];
      }

      var searchInputLower = this.searchInput.toLowerCase();

      var filteredTopics = void 0;
      filteredTopics = this.topicsCollection.where(function (obj) {
        if (obj['quickAccessCode'] !== undefined && obj['quickAccessCode'].toLowerCase() === searchInputLower) {
          return true;
        }

        if (obj['title'] !== undefined && obj['title'].toLowerCase().includes(searchInputLower)) {
          return true;
        }

        if (obj['description'] !== undefined && obj['description'].toLowerCase().includes(searchInputLower)) {
          return true;
        }

        for (var tagIdx in obj['tags']) {
          if (obj['tags'][tagIdx].toLowerCase().includes(searchInputLower)) {
            return true;
          }
        }
        return false;
      }).map(function (oldData) {
        return oldData['title'];
      });

      return this.filteredResources.branch().where(function (obj) {
        if (obj['quickAccessCode'] !== undefined && obj['quickAccessCode'].toLowerCase() === searchInputLower) {
          return true;
        }

        if (obj['title'] !== undefined && obj['title'].toLowerCase().includes(searchInputLower)) {
          return true;
        }

        var intInput = parseInt(_this2.searchInput);
        if (!isNaN(intInput)) {
          if (obj['page'] === intInput) {
            return true;
          }
          if (obj['chapter'] === intInput) {
            return true;
          }
        }

        for (var tagIdx in obj['tags']) {
          if (obj['tags'][tagIdx].toLowerCase().includes(searchInputLower)) {
            return true;
          }
        }

        if (filteredTopics.includes(obj['topic'])) {
          return true;
        }

        return false;
      }).simplesort('page').data();
    }
  },
  methods: {
    getLanguageString: function getLanguageString(lang) {
      if (lang === 'ar') {
        return 'Arabisch';
      } else if (lang === 'tr') {
        return 'Türkisch';
      } else if (lang === 'pr') {
        return 'Persisch';
      } else {
        return 'Unbekannt';
      }
    }
  }
});

/***/ }),

/***/ "hT2Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button-group',{class:{ 'd-inline': true, 'd-md-none': !_vm.alwaysVertical },attrs:{"size":"sm","vertical":""}},_vm._l((_vm.languageButtons),function(btn,idx){return _c('b-button',{key:idx,attrs:{"pressed":btn.selected,"disabled":_vm.disabled,"variant":_vm.buttonVariant},on:{"update:pressed":function($event){_vm.$set(btn, "selected", $event)}}},[_vm._v("\n      "+_vm._s(btn.caption)+"\n      "),(btn.selected)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!btn.selected)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)})),_vm._v(" "),(!_vm.alwaysVertical)?_c('b-button-group',{staticClass:"d-none d-md-inline",attrs:{"size":"sm"}},_vm._l((_vm.languageButtons),function(btn,idx){return _c('b-button',{key:idx,attrs:{"pressed":btn.selected,"disabled":_vm.disabled,"variant":_vm.buttonVariant},on:{"update:pressed":function($event){_vm.$set(btn, "selected", $event)}}},[_vm._v("\n      "+_vm._s(btn.caption)+"\n      "),(btn.selected)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Angezeigt")]):_vm._e(),_vm._v(" "),(!btn.selected)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Ausgeblendet")]):_vm._e()],1)})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hu0A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "izR6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/giz-mono.5e1290d.svg";

/***/ }),

/***/ "jEld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"navbar-dark sticky-top bg-dark",attrs:{"toggleable":"md","type":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__("izR6"),"id":"navbar-logo"}}),_vm._v("\n    ABC "),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Zusatzmaterialien")])]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":"/home","active-class":"active"}},[_c('icon',{staticClass:"symbol",attrs:{"name":"home","scale":"1.2"}}),_vm._v(" Start"),_c('span',{staticClass:"d-inline d-md-none d-lg-inline"},[_vm._v("seite")])],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/resources/search","active-class":"active"}},[_c('icon',{staticClass:"symbol",attrs:{"name":"search","scale":"1.1"}}),_vm._v(" Materialien"),_c('span',{staticClass:"d-inline d-md-none d-lg-inline"},[_vm._v(" suchen")])],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/resources/list","active-class":"active"}},[_c('icon',{staticClass:"symbol",attrs:{"name":"list","scale":"1.1"}}),_vm._v(" Alpha 1 & 2")],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/resources/topicList","active-class":"active"}},[_c('icon',{staticClass:"symbol",attrs:{"name":"list","scale":"1.1"}}),_vm._v(" Alpha 3 & 4")],1)],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{attrs:{"to":"/impress","active-class":"active"}},[_vm._v("Impressum")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lJOY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a883c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("vvEF");
function injectStyle (ssrContext) {
  __webpack_require__("Vej3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71a883c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71a883c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75115dde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("jEld");
function injectStyle (ssrContext) {
  __webpack_require__("wi3B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75115dde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75115dde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ls9i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing-background.8f705ee.jpg";

/***/ }),

/***/ "m/pI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__ = __webpack_require__("WWO0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6778ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__ = __webpack_require__("ucbF");
function injectStyle (ssrContext) {
  __webpack_require__("C+Qn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d6778ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6778ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mFnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"#EFEFEF"}},[_c('div',{staticClass:"container container-onepage",attrs:{"id":"fund"}},[_c('h3',[_vm._v("Gefördert durch:")]),_vm._v(" "),_c('p',{directives:[{name:"set-class-on-scroll-vertical",rawName:"v-set-class-on-scroll-vertical",value:('bounceIn'),expression:"'bounceIn'"}],staticClass:"animated"},[_c('img',{attrs:{"src":__webpack_require__("X22f")}}),_c('br'),_vm._v("\n        Gefördert mit Mitteln des Bundesministeriums für Bildung und Forschung.\n      ")])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-onepage",attrs:{"id":"impress"}},[_c('h2',[_vm._v("Impressum")]),_vm._v(" "),_c('h4',[_vm._v("Inhaltlich verantwortlich nach § 6 MDStV:")]),_vm._v(" "),_c('p',[_vm._v("\n      Gesellschaft für Interkulturelles Zusammenleben gGmbH."),_c('br'),_vm._v("\n      Ansprechpartnerin: Dr. Britta Marschke"),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("Anschrift:")]),_vm._v(" "),_c('p',[_vm._v("\n      Gesellschaft für Interkulturelles Zusammenleben gGmbH."),_c('br'),_vm._v("\n      Reformationsplatz 2"),_c('br'),_vm._v("\n      13597 Berlin"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      Tel: "),_c('a',{attrs:{"href":"tel:+4930513010000"}},[_vm._v("+49 30 513 0 100 00")]),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("Hinweise:")]),_vm._v(" "),_c('p',[_vm._v("\n      Rechtliche Hinweise entnehmen Sie bitte dem Haftungsausschluss weiter unten auf der Seite."),_c('br'),_vm._v("\n      Um uns zu kontaktieren, nutzen Sie bitte das Kontaktformular unter "),_c('a',{attrs:{"href":"https://giz.berlin/contact/main/form/4"}},[_vm._v("giz.berlin")]),_vm._v(".\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"legal"}},[_c('h3',[_vm._v("Haftungsausschluss")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Keine Abmahnung ohne vorherigen Kontakt!")]),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("1. Haftungsbeschränkung")]),_vm._v(" "),_c('p',[_vm._v("\n      Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Der Anbieter übernimmt jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte. Die Nutzung der Inhalte der Website erfolgt auf eigene Gefahr des Nutzers. Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen Autors und nicht immer die Meinung des Anbieters wieder. Mit der reinen Nutzung der Website des Anbieters kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande."),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("2. Externe Links")]),_vm._v(" "),_c('p',[_vm._v("\n      Diese Website kann Verknüpfungen oder Inhalte von bzw. zu Websites Dritter ( \"externe Links\" ) enthalten. Diese Websites unterliegen der Haftung der jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen Verknüpfung der externen Links die fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen. Der Anbieter hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich der Anbieter die hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige Kontrolle dieser externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch derartige externe Links unverzüglich gelöscht. Diese Adressen können sie uns, wenn wir sie nicht bemerken, hier mitteilen (Thema Webmaster)."),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("3. Urheber- und Leistungsschutzrechte")]),_vm._v(" "),_c('p',[_vm._v("\n      Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen Rechteinhabers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt."),_c('br'),_vm._v("\n      Außerdem ist die Darstellung dieser Website in fremden Frames (wie z.B. iframes) nur mit schriftlicher Erlaubnis zulässig."),_c('br')]),_vm._v(" "),_c('h4',[_vm._v("4. Besondere Hinweise")]),_vm._v(" "),_c('p',[_vm._v("\n      Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Nummern 1. bis 4. abweichen, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Falle gelten im jeweiligen Einzelfall die besonderen Nutzungsbedingungen. Für alle externen Dienste (wie z. B. google maps) gelten die Bedingungen der jeweiligen Betreiber des Dienstes. Diese iframes sind als externe Links zu betrachten und werden auch als solche behandelt.\n    ")]),_vm._v(" "),_c('h2',[_vm._v("Datenschutzerklärung")]),_vm._v(" "),_c('h3',[_vm._v("Verantwortliche")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Firma: Gesellschaft für interkulturelles Zusammenleben gGmbH.")]),_vm._v(" "),_c('li',[_vm._v("Adresse: Reformationsplatz 2, 13597 Berlin")]),_vm._v(" "),_c('li',[_vm._v("Geschäftsführerin: Britta Marschke")]),_vm._v(" "),_c('li',[_vm._v("Handesregisternummer HRB 200872 B")]),_vm._v(" "),_c('li',[_vm._v("Telefon: +49 30 / 513 0 100 00")]),_vm._v(" "),_c('li',[_vm._v("E-Mail: info [at] giz.berlin")])]),_vm._v(" "),_c('h3',[_vm._v("Datenschutzbeauftragter")]),_vm._v(" "),_c('p',[_vm._v("\n      Unser Datenschutzbeauftragter ist unter der Adresse datenschutz [at] giz.berlin zu erreichen.\n    ")]),_vm._v(" "),_c('h3',[_vm._v("Datenschutzerklärung")]),_vm._v(" "),_c('p',[_vm._v("Stand: 11.11.2018")]),_vm._v(" "),_c('h4',[_vm._v("Grundsätzliche Angaben zur Datenverarbeitung und Rechtsgrundlagen")]),_vm._v(" "),_c('p',[_vm._v("\n      Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten innerhalb unseres Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und Inhalte (nachfolgend gemeinsam bezeichnet als „Onlineangebot“ oder „Website“) auf. Die Datenschutzerklärung gilt unabhängig von den verwendeten Domains, Systemen, Plattformen und Geräten (z.B. Desktop oder Mobile) auf denen das Onlineangebot ausgeführt wird.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Die verwendeten Begrifflichkeiten, wie z.B. „personenbezogene Daten“ oder deren „Verarbeitung“ verweisen wir auf die Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Zu den im Rahmen dieses Onlineangebotes verarbeiteten personenbezogenen Daten der Nutzer gehören Bestandsdaten (z.B., Namen und Adressen von Kunden), Vertragsdaten (z.B., in Anspruch genommene Leistungen, Namen von Sachbearbeitern, Zahlungsinformationen), Nutzungsdaten (z.B., die besuchten Webseiten unseres Onlineangebotes, Interesse an unseren Produkten) und Inhaltsdaten (z.B., Eingaben im Kontaktformular).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Der Begriff „Nutzer“ umfasst alle Kategorien von der Datenverarbeitung betroffener Personen. Zu ihnen gehören unsere Geschäftspartner, Kunden, Interessenten und sonstige Besucher unseres Onlineangebotes. Die verwendeten Begrifflichkeiten, wie z.B. „Nutzer“ sind geschlechtsneutral zu verstehen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir verarbeiten personenbezogene Daten der Nutzer nur unter Einhaltung der einschlägigen Datenschutzbestimmungen. Das bedeutet, die Daten der Nutzer werden nur bei Vorliegen einer gesetzlichen Erlaubnis verarbeitet. D.h., insbesondere wenn die Datenverarbeitung zur Erbringung unserer vertraglichen Leistungen (z.B. Bearbeitung von Aufträgen) sowie Online-Services erforderlich, bzw. gesetzlich vorgeschrieben ist, eine Einwilligung der Nutzer vorliegt, als auch aufgrund unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb und Sicherheit unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO, insbesondere bei der Reichweitenmessung, Erstellung von Profilen zu Werbe- und Marketingzwecken sowie Erhebung von Zugriffsdaten und Einsatz der Dienste von Drittanbietern.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir weisen darauf hin, dass die Rechtsgrundlage der Einwilligungen Art. 6 Abs. 1 lit. a. und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer Leistungen und Durchführung vertraglicher Maßnahmen Art. 6 Abs. 1 lit. b. DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen Art. 6 Abs. 1 lit. c. DSGVO, und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer berechtigten Interessen Art. 6 Abs. 1 lit. f. DSGVO ist.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Sicherheitsmaßnahmen")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir treffen organisatorische, vertragliche und technische Sicherheitsmaßnahmen entsprechend dem Stand der Technik, um sicherzustellen, dass die Vorschriften der Datenschutzgesetze eingehalten werden und um damit die durch uns verarbeiteten Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Zu den Sicherheitsmaßnahmen gehört insbesondere die größtenteils verschlüsselte Übertragung von Daten zwischen Ihrem Browser und unserem Server.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Weitergabe von Daten an Dritte und Drittanbieter")]),_vm._v(" "),_c('p',[_vm._v("\n      Eine Weitergabe von Daten an Dritte erfolgt nur im Rahmen der gesetzlichen Vorgaben. Wir geben die Daten der Nutzer an Dritte nur dann weiter, wenn dies z.B. auf Grundlage des Art. 6 Abs. 1 lit. b) DSGVO für Vertragszwecke erforderlich ist oder auf Grundlage berechtigter Interessen gem. Art. 6 Abs. 1 lit. f. DSGVO an wirtschaftlichem und effektivem Betrieb unseres Geschäftsbetriebes.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Sofern wir Subunternehmer einsetzen, um unsere Leistungen bereitzustellen, ergreifen wir geeignete rechtliche Vorkehrungen sowie entsprechende technische und organisatorische Maßnahmen, um für den Schutz der personenbezogenen Daten gemäß den einschlägigen gesetzlichen Vorschriften zu sorgen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Sofern im Rahmen dieser Datenschutzerklärung Inhalte, Werkzeuge oder sonstige Mittel von anderen Anbietern (nachfolgend gemeinsam bezeichnet als „Drittanbieter“) eingesetzt werden und deren genannter Sitz sich in einem Drittland befindet, ist davon auszugehen, dass ein Datentransfer in die Sitzstaaten der Drittanbieter stattfindet. Als Drittstaaten sind Länder zu verstehen, in denen die DSGVO kein unmittelbar geltendes Recht ist, d.h. grundsätzlich Länder außerhalb der EU, bzw. des Europäischen Wirtschaftsraums. Die Übermittlung von Daten in Drittstaaten erfolgt entweder, wenn ein angemessenes Datenschutzniveau, eine Einwilligung der Nutzer oder sonst eine gesetzliche Erlaubnis vorliegt.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Erbringung vertraglicher Leistungen")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir verarbeiten Bestandsdaten (z.B., Namen und Adressen sowie Kontaktdaten von Nutzern), Vertragsdaten (z.B., in Anspruch genommene Leistungen, Namen von Kontaktpersonen, Zahlungsinformationen) zwecks Erfüllung unserer vertraglichen Verpflichtungen und Serviceleistungen gem. Art. 6 Abs. 1 lit b. DSGVO.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Nutzer können optional ein Nutzerkonto anlegen. Im Rahmen der Registrierung, werden die erforderlichen Pflichtangaben den Nutzern mitgeteilt. Die Nutzerkonten sind nicht öffentlich und können von Suchmaschinen nicht indexiert werden. Wenn Nutzer ihr Nutzerkonto gekündigt haben, werden deren Daten im Hinblick auf das Nutzerkonto gelöscht, vorbehaltlich deren Aufbewahrung ist aus handels- oder steuerrechtlichen Gründen entspr. Art. 6 Abs. 1 lit. c DSGVO notwendig. Es obliegt den Nutzern, ihre Daten bei erfolgter Kündigung vor dem Vertragsende zu sichern. Wir sind berechtigt, sämtliche während der Vertragsdauer gespeicherten Daten des Nutzers unwiederbringlich zu löschen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Im Rahmen der Registrierung und erneuter Anmeldungen sowie Inanspruchnahme unserer Onlinedienste, speichern wird die IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung. Die Speicherung erfolgt auf Grundlage unserer berechtigten Interessen, als auch der Nutzer an Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer sie ist zur Verfolgung unserer Ansprüche erforderlich oder es besteht hierzu besteht eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1 lit. c DSGVO.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir verarbeiten Nutzungsdaten (z.B., die besuchten Webseiten unseres Onlineangebotes, Interesse an unseren Produkten) und Inhaltsdaten (z.B., Eingaben im Kontaktformular oder Nutzerprofil) für Werbezwecke in einem Nutzerprofil.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Kontaktaufnahme")]),_vm._v(" "),_c('p',[_vm._v("\n      Bei der Kontaktaufnahme mit uns (per Kontaktformular oder E-Mail) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1 lit. b) DSGVO verarbeitet.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Erhebung von Zugriffsdaten und Logfiles")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir erheben auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten gehören Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung über erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur Aufklärung von Missbrauchs- oder Betrugshandlungen) für die Dauer von maximal 30 Tagen gespeichert und danach gelöscht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Cookies & Reichweitenmessung")]),_vm._v(" "),_c('p',[_vm._v("\n      Cookies sind Informationen, die von unserem Webserver oder Webservern Dritter an die Web-Browser der Nutzer übertragen und dort für einen späteren Abruf gespeichert werden. Bei Cookies kann es sich um kleine Dateien oder sonstige Arten der Informationsspeicherung handeln.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir verwenden „Session-Cookies“, die nur für die Zeitdauer des aktuellen Besuchs auf unserer Onlinepräsenz abgelegt werden (z.B. um die Speicherung Ihres Login-Status oder die Warenkorbfunktion und somit die Nutzung unseres Onlineangebotes überhaupt ermöglichen zu können). In einem Session-Cookie wird eine zufällig erzeugte eindeutige Identifikationsnummer abgelegt, eine sogenannte Session-ID. Außerdem enthält ein Cookie die Angabe über seine Herkunft und die Speicherfrist. Diese Cookies können keine anderen Daten speichern. Session-Cookies werden gelöscht, wenn Sie die Nutzung unseres Onlineangebotes beendet haben und sich z.B. ausloggen oder den Browser schließen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir verwenden Cookies darüber hinaus für einige persönliche Einstellungen des Nutzers.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Über den Einsatz von Cookies im Rahmen pseudonymer Reichweitenmessung werden die Nutzer im Rahmen dieser Datenschutzerklärung informiert.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner gespeichert werden, werden sie gebeten die entsprechende Option in den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte Cookies können in den Systemeinstellungen des Browsers gelöscht werden. Der Ausschluss von Cookies kann zu Funktionseinschränkungen dieses Onlineangebotes führen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Sie können dem Einsatz von Cookies, die der Reichweitenmessung und Werbezwecken dienen, über die Deaktivierungsseite der "),_c('a',{attrs:{"href":"http://optout.networkadvertising.org/"}},[_vm._v("Netzwerkwerbeinitiative")]),_vm._v(" und zusätzlich die US-amerikanische "),_c('a',{attrs:{"href":"http://www.aboutads.info/choices"}},[_vm._v("Webseite")]),_vm._v(" oder die europäische "),_c('a',{attrs:{"href":"http://www.youronlinechoices.com/uk/your-ad-choices/"}},[_vm._v("Webseite")]),_vm._v(" widersprechen.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Reichweitenanalyse mit Matomo (ehemals PIWIK)")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir nutzen auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Matomo, eine Open-Source-Software zur statistischen Auswertung der Nutzerzugriffe. Die IP-Adresse der Nutzer wird gekürzt, bevor sie gespeichert wird. Matomo verwendet jedoch Cookies, die auf dem Computer der Nutzer gespeichert werden und die eine Analyse der Benutzung dieses Onlineangebotes durch die Nutzer ermöglichen. Dabei können aus den verarbeiteten Daten pseudonyme Nutzungsprofile der Nutzer erstellt werden.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieses Onlineangebotes werden auf unserem Server gespeichert.\n    ")]),_vm._v(" "),_c('iframe',{staticStyle:{"border":"0","height":"200px","width":"600px"},attrs:{"src":"https://piwik.giz.berlin/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=&fontFamily="}}),_vm._v(" "),_c('h4',[_vm._v("Einbindung von Diensten und Inhalten Dritter")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet als “Inhalte”). Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte nicht an deren Browser senden könnten. Die IP-Adresse ist damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Drittanbieter können ferner so genannte Pixel-Tags (unsichtbare Grafiken, auch als \"Web Beacons\" bezeichnet) für statistische oder Marketingzwecke verwenden. Durch die \"Pixel-Tags\" können Informationen, wie der Besucherverkehr auf den Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen können ferner in Cookies auf dem Gerät der Nutzer gespeichert werden und unter anderem technische Informationen zum Browser und Betriebssystem, verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung unseres Onlineangebotes enthalten, als auch mit solchen Informationen aus anderen Quellen verbunden werden können.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Rechte der Nutzer")]),_vm._v(" "),_c('p',[_vm._v("\n      Nutzer haben das Recht, auf Antrag unentgeltlich Auskunft zu erhalten über die personenbezogenen Daten, die von uns über sie gespeichert wurden.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Zusätzlich haben die Nutzer das Recht auf Berichtigung unrichtiger Daten, Einschränkung der Verarbeitung und Löschung ihrer personenbezogenen Daten, sofern zutreffend, Ihre Rechte auf Datenportabilität geltend zu machen und im Fall der Annahme einer unrechtmäßigen Datenverarbeitung, eine Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Ebenso können Nutzer Einwilligungen, grundsätzlich mit Auswirkung für die Zukunft, widerrufen.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Löschung von Daten")]),_vm._v(" "),_c('p',[_vm._v("\n      Die bei uns gespeicherten Daten werden gelöscht, sobald sie für ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten der Nutzer nicht gelöscht werden, weil sie für andere und gesetzlich zulässige Zwecke erforderlich sind, wird deren Verarbeitung eingeschränkt. D.h. die Daten werden gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z.B. für Daten der Nutzer, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden müssen.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Nach gesetzlichen Vorgaben erfolgt die Aufbewahrung für 6 Jahre gemäß § 257 Abs. 1 HGB (Handelsbücher, Inventare, Eröffnungsbilanzen, Jahresabschlüsse, Handelsbriefe, Buchungsbelege, etc.) sowie für 10 Jahre gemäß § 147 Abs. 1 AO (Bücher, Aufzeichnungen, Lageberichte, Buchungsbelege, Handels- und Geschäftsbriefe, Für Besteuerung relevante Unterlagen, etc.).\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Widerspruchsrecht")]),_vm._v(" "),_c('p',[_vm._v("\n      Nutzer können der künftigen Verarbeitung ihrer personenbezogenen Daten entsprechend den gesetzlichen Vorgaben jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke der Direktwerbung erfolgen.\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Änderungen der Datenschutzerklärung")]),_vm._v(" "),_c('p',[_vm._v("\n      Wir behalten uns vor, die Datenschutzerklärung zu ändern, um sie an geänderte Rechtslagen, oder bei Änderungen des Dienstes sowie der Datenverarbeitung anzupassen. Dies gilt jedoch nur im Hinblick auf Erklärungen zur Datenverarbeitung. Sofern Einwilligungen der Nutzer erforderlich sind oder Bestandteile der Datenschutzerklärung Regelungen des Vertragsverhältnisses mit den Nutzern enthalten, erfolgen die Änderungen nur mit Zustimmung der Nutzer.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Die Nutzer werden gebeten sich regelmäßig über den Inhalt der Datenschutzerklärung zu informieren.\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n2q4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n4XD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container-fluid",attrs:{"id":"footer-pre"}}),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('p',{staticClass:"mt-4 text-center"},[_c('a',{attrs:{"href":"https://bmbf.de"}},[_c('img',{staticClass:"text-center mt-3",attrs:{"src":__webpack_require__("X22f"),"height":"130px"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('p',{staticClass:"mt-4 text-center"},[_c('a',{attrs:{"href":"https://bmbf.de"}},[_c('img',{staticClass:"text-center mt-3",attrs:{"src":__webpack_require__("egv2"),"width":"100%"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('p',{staticClass:"text-muted text-center"},[_vm._v("\n          KASA ist ein Projekt der "),_c('a',{attrs:{"href":"https://giz.berlin"}},[_vm._v("\n            GIZ gGmbH\n          ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://giz.berlin"}},[_c('img',{staticClass:"text-center mt-3",attrs:{"src":__webpack_require__("wntv"),"height":"150px"}})])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('p',{staticClass:"text-muted text-justify text-small mt-5"},[_vm._v("\n          Dieses Vorhaben wird mit Mitteln des Bundesministeriums für Bildung und Forschung unter dem Förderkennzeichen W1451KASA gefördert. Die Verantwortung für den Inhalt dieser Veröffentlichung liegt beim Autor.\n        ")]),_vm._v(" "),_c('p',{staticClass:"text-muted text-right text-small mt-5"},[_vm._v("\n          © GIZ gGmbH "+_vm._s(_vm.year)+" | "),_c('router-link',{attrs:{"to":"/impress"}},[_vm._v("\n            Impressum\n          ")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nq5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__ = __webpack_require__("t2Vd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67002726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__ = __webpack_require__("n4XD");
function injectStyle (ssrContext) {
  __webpack_require__("sgY/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67002726"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67002726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oIcX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BACKEND_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESOURCES_LANGUAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SURE_BOOK_21_REDIRECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KASA_BOOK_21_REDIRECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_TYPE_MAP; });
var BACKEND_BASE_URL = 'http://localhost:5000';
var RESOURCES_LANGUAGES = {
  'tr': {
    name: 'Türkisch'
  },
  'ar': {
    name: 'Arabisch'
  },
  'pr': {
    name: 'Persisch'
  }
};

var SURE_BOOK_21_REDIRECTIONS = {
  1: 'https://peertube.giz.berlin/videos/watch/11e9185c-d09a-4a43-8974-3bd3ad1de746',
  2: 'https://peertube.giz.berlin/videos/watch/cd68d86d-7a84-42a3-b5c8-aa87eeed45a9',
  3: 'https://peertube.giz.berlin/videos/watch/d845e543-7ddb-4bc9-9833-5c524ff9b9d4',
  4: 'https://peertube.giz.berlin/videos/watch/c1adf0ca-b3b6-49fd-bcc0-236b6b5a60c9',
  5: 'https://peertube.giz.berlin/videos/watch/940ec666-0c45-4fc3-afcc-5761dcf51518',
  6: 'https://peertube.giz.berlin/videos/watch/3d4da4f9-9b8c-43e6-adea-51dbba896612',
  7: 'https://peertube.giz.berlin/videos/watch/5dd1e286-1c06-4bbd-8e5f-449928f8c916',
  8: 'https://peertube.giz.berlin/videos/watch/ee257919-6145-4371-b516-1c8166069c25',
  9: 'https://peertube.giz.berlin/videos/watch/f4d2ce1d-1394-4fbc-9195-8d81736f4e62',
  10: 'https://peertube.giz.berlin/videos/watch/3392dc6b-a626-4e12-9aa7-1f276556a5ce',
  11: 'https://peertube.giz.berlin/videos/watch/9ad7fed7-24d1-496a-b128-255b1d8b9fae',
  12: 'https://peertube.giz.berlin/videos/watch/ffe5abb5-e1e6-4ee0-82d8-4ba52544d03d',
  13: 'https://peertube.giz.berlin/videos/watch/1de614ab-0b4b-41b7-8384-125d499ba941',
  14: 'https://sure.giz.berlin/about'
};

var KASA_BOOK_21_REDIRECTIONS = {
  'zimmer_situationsansatz': 'https://peertube.giz.berlin/videos/watch/a8f86bbd-c3dd-47fd-9d01-202be884c3de',
  'zimmer_lernort': 'https://peertube.giz.berlin/videos/watch/8b81339a-39f7-42bf-a6d9-b5497ee30f0e',
  'zimmer_muttersprache': 'https://peertube.giz.berlin/videos/watch/9255d756-39fc-43f0-bd46-5f12a21be22f',
  'zimmer_alphabetisierung': 'https://peertube.giz.berlin/videos/watch/2c93d4d0-8401-4839-baab-6695dd204fdf',
  'abcami_visuelles_gedicht': 'https://peertube.giz.berlin/videos/watch/9a8aac8f-43ff-40bc-9765-e719eb78051a',
  'kasa_erklaervideo': 'https://peertube.giz.berlin/videos/watch/c8241179-2ceb-4d9f-9c4d-10b8b9fd9a0f',
  'grammatikvideos': 'https://peertube.giz.berlin/w/p/3TpAxi2kDDXWkqFWwLD3VN'
};

var FILE_TYPE_MAP = {
  'text': {
    name: 'Text',
    extensions: ['pdf', 'txt']
  },
  'audio': {
    name: 'Audio',
    extensions: ['wav', 'mp3', 'ogg']
  },
  'pictures': {
    name: 'Bilder',
    extensions: ['jpg', 'png', 'svg']
  },
  'video': {
    name: 'Video',
    extensions: ['peertubeId']
  }
};

/***/ }),

/***/ "p7qi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceTopicList_vue__ = __webpack_require__("tM3q");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b283ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceTopicList_vue__ = __webpack_require__("Mk1x");
function injectStyle (ssrContext) {
  __webpack_require__("3b9N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48b283ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceTopicList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b283ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceTopicList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qQ2Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sgY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "shih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__ = __webpack_require__("bPT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__ = __webpack_require__("XZl9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Loki = __webpack_require__("7WZj");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceSearchKasaBook21',
  data: function data() {
    return {
      searchInput: ''
    };
  },

  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_1__ResourceTypeFilter__["a" /* default */],
    ResourceLangFilter: __WEBPACK_IMPORTED_MODULE_2__ResourceLangFilter__["a" /* default */]
  },
  mounted: function mounted() {
    this.$http.get('/static/resourceDB.json').then(function (response) {
      this.db = new Loki('resources');
      this.db.loadJSONObject(response.body);
      this.resourceCollection = this.db.getCollection('resources');

      if (this.$route.params.searchString) {
        this.searchInput = this.$route.params.searchString;
      }
    });
  },

  computed: {
    searchResult: function searchResult() {
      var _this = this;

      if (this.searchInput === '') {
        return [];
      }

      return this.resourceCollection.chain().where(function (obj) {
        if (obj['kasa_book_21_ref'] !== undefined && obj['kasa_book_21_ref'] === _this.searchInput) {
          return true;
        }

        return false;
      }).simplesort('page').data();
    }
  }
});

/***/ }),

/***/ "t2Vd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Foot',
  computed: {
    year: function year() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),

/***/ "tM3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__("m/pI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceTypeFilter__ = __webpack_require__("bPT8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Loki = __webpack_require__("7WZj");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourceTopicList',
  data: function data() {
    var languageButtons = [];
    var selected = true;
    for (var lang in __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RESOURCES_LANGUAGES */]) {
      languageButtons.push({
        caption: __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RESOURCES_LANGUAGES */][lang]['name'],
        langCode: lang,
        selected: selected
      });
      // selected = false
    }

    return {
      resourceCollection: null,
      topicsCollection: null,
      db: null,
      languageButtons: languageButtons
    };
  },
  components: {
    Resource: __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* default */],
    ResourceTypeFilter: __WEBPACK_IMPORTED_MODULE_2__ResourceTypeFilter__["a" /* default */]
  },
  mounted: function mounted() {
    this.$http.get('/static/resourceDB.json').then(function (response) {
      var _this = this;

      this.db = new Loki('resources');
      this.db.loadJSONObject(response.body);
      this.resourceCollection = this.db.getCollection('resources');
      this.topicsCollection = this.db.getCollection('topics');

      this.$nextTick(function () {
        _this.$forceUpdate();
      });
    });
  },

  computed: {
    filteredResources: function filteredResources() {
      var _this2 = this;

      if (this.resourceCollection !== null) {
        return this.resourceCollection.chain().where(function (obj) {
          if (_this2.$refs.resourceTypeFilter !== undefined) {
            return _this2.$refs.resourceTypeFilter.filterSelectedObjects(obj);
          }
          return false;
        }).simplesort('page');
      }
    },
    searchResult: function searchResult() {
      var result = [];
      if (this.resourceCollection === null) {
        return result;
      }
      for (var tocIdx in this.toc['toc']) {
        var partResult = {
          topic: this.toc['toc'][tocIdx],
          entries: this.topicSearchResult(this.toc['toc'][tocIdx]['title']).data()
        };
        if (partResult['entries'].length > 0) {
          result.push(partResult);
        }
      }
      return result;
    },
    toc: function toc() {
      if (this.topicsCollection === null) {
        return {
          toc: []
        };
      }

      return {
        toc: this.topicsCollection.chain().data()
      };
    }
  },
  methods: {
    getUniqueIdForEntry: function getUniqueIdForEntry(entry) {
      return 'entry_' + this.hashCode(entry);
    },
    offsetTop: function offsetTop(el) {
      // Return an element's offset wrt document element
      // https://j11y.io/jquery/#v=git&fn=jQuery.fn.offset
      if (!el.getClientRects().length) {
        return 0;
      }
      var bcr = el.getBoundingClientRect();
      var win = el.ownerDocument.defaultView;
      return bcr.top + win.pageYOffset;
    },
    scrollIntoView: function scrollIntoView(evt, href) {
      // taken from https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/docs/components/toc.vue
      evt.preventDefault();
      evt.stopPropagation();
      // We use an attribute `querySelector()` rather than `getElementByID()`,
      // as some auto-generated ID's are invalid or not unique
      var id = (href || '').replace(/#/g, '');
      var $el = document.body.querySelector('[id="' + id + '"]');
      if ($el) {
        // Get the document scrolling element
        var scroller = document.scrollingElement || document.documentElement || document.body;
        // Scroll heading into view (minus offset to account for nav top height
        scrollTo(scroller, this.offsetTop($el) - 70, 100, function () {
          // Set a tab index so we can focus header for a11y support
          $el.tabIndex = -1;
          // Focus the heading
          $el.focus();
        });
      }
    },

    hashCode: function hashCode(str) {
      // taken from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
      return str.split('').reduce(function (prevHash, currVal) {
        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
      }, 0);
    },
    topicSearchResult: function topicSearchResult(topic) {
      if (this.resourceCollection !== null) {
        return this.filteredResources.branch().where(function (obj) {
          return obj['topic'] === topic;
        });
      }
    },
    topicSearchResultUnfiltered: function topicSearchResultUnfiltered(topic) {
      if (this.resourceCollection !== null) {
        return this.resourceCollection.where(function (obj) {
          return obj['topic'] === topic;
        });
      }
    }
  }
});

/***/ }),

/***/ "tbYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ucbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"fadeIn animated",attrs:{"title":_vm.resource.title}},[_c('p',{staticClass:"card-text text-muted"},[_vm._v("\n    Schnellzugriffscode: "+_vm._s(_vm.resource.quickAccessCode)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[(_vm.resource.fileType === 'audio')?_c('audio',{attrs:{"src":_vm.resource.filePath,"controls":""}},[_vm._v("Audio-Datei herunterladen, um sie abzsupielen.")]):_vm._e()]),_vm._v(" "),(_vm.resource.fileExtension == 'peertubeId')?_c('div',{staticClass:"peertube-embed-container"},[_c('iframe',{attrs:{"allowfullscreen":"","frameborder":"0","sandbox":"allow-same-origin allow-scripts","src":'https://peertube.giz.berlin/videos/embed/' + _vm.resource.peertubeId}})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n    "+_vm._s(_vm.resource.description)+"\n  ")]),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.resource.topic)?_c('div',{staticClass:"mt-2 float-left"},[_vm._v(_vm._s(_vm.resource.title)+": Zusatzinhalt "+_vm._s(_vm.resource.topic))]):_c('div',{staticClass:"mt-2 float-left"},[_vm._v(_vm._s(_vm.resource.title)+": Kapitel "+_vm._s(_vm.resource.chapter)),(_vm.resource.page)?[_vm._v(" / Seite "+_vm._s(_vm.resource.page))]:_vm._e()],2),_vm._v(" "),(_vm.resource.fileExtension === 'peertubeId')?_c('b-button',{staticClass:"float-right",attrs:{"href":'https://peertube.giz.berlin/w/' + _vm.resource.peertubeId,"target":"_blank","variant":"primary"}},[_c('icon',{attrs:{"name":"link"}}),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Peertube")])],1):_c('b-button',{staticClass:"float-right",attrs:{"href":_vm.resource.filePath,"target":"_blank","variant":"primary"}},[_c('icon',{attrs:{"name":"download"}}),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Herunterladen")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uq+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Impress'
});

/***/ }),

/***/ "v4ny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceKasaBook21m_vue__ = __webpack_require__("Et53");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646a3859_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceKasaBook21m_vue__ = __webpack_require__("8MQg");
function injectStyle (ssrContext) {
  __webpack_require__("hu0A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-646a3859"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceKasaBook21m_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646a3859_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceKasaBook21m_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vS+j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vvEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid",style:({ backgroundImage: ("url('" + (__webpack_require__("ls9i")) + "')") }),attrs:{"id":"landing-container"}},[_c('div',{staticClass:"container container-onepage",attrs:{"id":"landing"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col"},[_c('div',{staticClass:"row-aligned-content"},[_c('img',{attrs:{"src":__webpack_require__("wntv"),"width":"25%"}}),_vm._v(" "),_c('h2',[_vm._v("Zusatzmaterialien")]),_vm._v(" "),_c('p',[_vm._v("Hier können Sie Zusatzmaterial kostenfrei "),_c('router-link',{attrs:{"to":"/resources"}},[_vm._v("herunterladen.")])],1),_vm._v(" "),_c('p',[_vm._v("\n              Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist\n              seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wi3B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wntv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/giz.e8262ad.svg";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_cookie_law__ = __webpack_require__("Ecwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_cookie_law__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar_vue__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Foot__ = __webpack_require__("nq5D");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'foot': __WEBPACK_IMPORTED_MODULE_2__components_Foot__["a" /* default */],
    'navbar': __WEBPACK_IMPORTED_MODULE_1__components_Navbar_vue__["a" /* default */],
    'cookie-law': __WEBPACK_IMPORTED_MODULE_0_vue_bootstrap_cookie_law___default.a
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ea6b13e97df3ed2aaeae.js